module.exports = __webpack_public_path__ + "img/qiyedys.60cdf6d7.png";